import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { fetchingSemanticArticles } from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingSemanticArticles.started, state => ({
        ...state,
        loading: true,
    }))
    .case(
        fetchingSemanticArticles.done,
        (state, { result: { title, articles, themeId: themeHash, totalCount } }) => ({
            ...state,
            title,
            articles,
            themeHash,
            totalCount,
            loading: false,
        }),
    )
    .case(fetchingSemanticArticles.failed, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    }));

export default reducer;
